import { quantityOrderedStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityOrdered";
import { css } from "styled-components";

quantityOrderedStyles.quantityOrdered = {
    cssOverrides: {
        formField: 
            css`
                > label {
                    display: none;
                }
            `,
        formInputWrapper: 
            css`
                margin-top: 0 !important;
            `,
    },
}